import React, { useEffect } from 'react';

import ProductGridWithFilters from '~/components/collection/ProductGridWithFilters';
import { productFragment } from '~/utils/queries';
import useParams from '~/hooks/useParams';
import webstoreTracker, {
  ContentGroups,
} from '~/helpers/trackers/webstoreTrackerWrapper';

// These filters form the basis of all secondary requests (on changes to filters or pagination)
const queryFilters =
  '$itemsPerPage: Int!, $page: Int!, $query: String!, $order: ProductOrder';
const productsFilters =
  'first: $itemsPerPage, page: $page, query: $query, order: $order';

// This query gets pagination and product data it should be nested within a
// call to the products resource
const productsQuery = `
  paginatorInfo {
    count
    total
    currentPage
    lastPage
  }
  data {
    ${productFragment}
  }
`;

// This query gets all secondary search page states (on changes to filters or pagination)
const searchQuery = `
  query(${queryFilters}) {
    products(${productsFilters}) {
      ${productsQuery}
    }
  }
`;

const Search = () => {
  const { getParam } = useParams();
  const variables = {
    query: getParam('q'),
  };

  useEffect(() => {
    webstoreTracker.tagGroup(ContentGroups.Search);
  }, []);

  return (
    <ProductGridWithFilters
      query={searchQuery}
      variables={variables}
      queryFilters={queryFilters}
      productsFilters={productsFilters}
      requestType="searchPage"
    />
  );
};

export default Search;
